import { Widget } from '@/components/widget';
import { useState } from 'react';
import { useListener } from '@/hooks/use-listener';
import { useGetContainer } from '@/features/containers/hooks/use-get-container';
import { ContainerEditForm } from '@/features/containers/components/container-edit-form';

interface ContainerDetailWidgetProps {
  id: string;
}

export function ContainerDetailWidget({ id }: ContainerDetailWidgetProps) {
  const [containerUuid, setContainerUuid] = useState<string | null>(null);
  const { data: containerData } = useGetContainer(containerUuid!);
  const { removeMessage } = useListener({
    id,
    listenerFn: (data) => {
      setContainerUuid(data?.[0]?.uuid || null);
    },
    type: 'ObjectCollection',
  });

  function handleCreate(uuid: string) {
    removeMessage();
    setContainerUuid(uuid);
  }

  function handleNew() {
    setContainerUuid(null);
    removeMessage();
  }

  function handleDelete() {
    setContainerUuid(null);
    removeMessage();
  }

  return (
    <Widget id={id} title="Container Details">
      <ContainerEditForm
        key={containerData?.uuid}
        data={containerData}
        onCreate={handleCreate}
        onNew={handleNew}
        onDelete={handleDelete}
        widgetId={id}
      />
    </Widget>
  );
}
